import React, { useMemo } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { dataloadToPlayerDataFlat } from '../util/PlayerDataUtil'
import { useAppSelector } from '../../app/hooks'
import './index.css';
import { Player } from '../../sdk/model';
import { getColorByPosition } from '../util/ColorByPosition'
import {Box, Typography, Avatar, Modal} from '@mui/material';
import PlayerInfoCard from '../cards/playerCard';

//Using https://www.material-react-table.com/docs/examples/basic

const SelectPlayer = ({rookieYear, unavailablePlayers, playerSelection, setPlayerSelection, queue, setQueue, leagueId}) => {
  const [viewingPlayer, setViewingPlayer] = React.useState<Player | undefined>(undefined);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: 'quick_stats.rankOnYear', //access nested data with dot notation
        id: 'rank',
        header: 'Rank',
        minSize: 15,
        size: 15,
      },
      {
        accessorFn: (row) => `${row.first_name || ''} ${row.last_name || ''} ${row.abbr_name || ''}`.trim(),
        header: 'Name',
        size: 75,
        Cell: ({ row }) => (
          <Box 
            onClick={() => setViewingPlayer(row.original)}
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              cursor: 'pointer',
              '&:hover': { opacity: 0.8 }
            }}
          >
            <Avatar 
              alt={row.original.abbr_name} 
              src={row.original.picture}
              sx={{ width: 40, height: 40, mr: 1.5 }}
            />
            <Typography 
              variant="body2" 
              sx={{ fontWeight: 'bold', color: 'black' }}
            >
              {row.original.abbr_name || `${row.original.first_name} ${row.original.last_name}`}
            </Typography>
          </Box>
        )
      },
      {
        accessorKey: 'position', //normal accessorKey
        id: 'position',
        header: 'Position',
        minSize: 15,
        size: 15,
      },
      {
        accessorKey: 'nfl_team.alias',
        header: 'Team',
        minSize: 15,
        size: 15,
      },
      {
        accessorKey: 'ageYears',
        header: 'Age',
        minSize: 15,
        size: 15,
      },
      {
        accessorKey: 'college',
        header: 'College',
        minSize: 15,
        size: 15,
      }
    ],
    [],
  );

  // TODO: Make this happen at the top level so we are not reloading the data every time
  const playerDataLoad = useAppSelector((state) => state.playerDataLoad );

  console.log("Player Data Load: ");
  console.log(playerDataLoad);
  
  // IMPORTANT: This is where we are loading the data into the table
  const [data, setData] = React.useState<Player[]>([])
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
  });

  function filter(players) {
    if (queue) {
      players = queue.map(queuedPlayerId => players.find(player => player.id === queuedPlayerId));
    }
    if (rookieYear) {
      players = players.filter(player => player.rookie_year === rookieYear);
    }
    if (unavailablePlayers) {
	  players = players.filter(player => !unavailablePlayers.has(player.id));
    }
    return players;
  }

  React.useEffect(() => {
    setData(filter(dataloadToPlayerDataFlat(playerDataLoad)));
    if (Object.keys(playerSelection).length > 0 && unavailablePlayers.has(Object.keys(playerSelection)[0])) {
	  setPlayerSelection({});
    }
  }, [playerDataLoad, unavailablePlayers]);

  console.log("Player Selection: " + playerSelection);  

  if(setPlayerSelection === undefined || setPlayerSelection === null)  {
    console.log("setPlayerSelection is null, not rendering row selection");  
    return <MaterialReactTable columns={columns} data={data}
      ></MaterialReactTable>
  }

  console.log("setPlayerSelection is not null, rendering row selection")
  return <Box>
    <Modal open={viewingPlayer !== undefined} onClose={() => setViewingPlayer(undefined)} 
          aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description"
          sx={{margin: '5%'}}>
        <PlayerInfoCard player={viewingPlayer} leagueId={leagueId}/>
      </Modal>
    <MaterialReactTable enableRowSelection={true} enableMultiRowSelection={false} 
      onRowSelectionChange={setPlayerSelection} state={{ rowSelection : playerSelection, pagination}} 
      getRowId={(row) => row.id} columns={columns} 
      data={data.filter((player) => player?.quick_stats?.rankOnYear !== -1)} 
      enableRowOrdering={queue} enableRowSorting={!queue} autoResetPageIndex={false}
      onPaginationChange={newPagination => {
        const nextState = newPagination(pagination);
        if (nextState.pageIndex !== pagination.pageIndex || nextState.pageSize !== pagination.pageSize) {
          setPagination(nextState);
        }
      }}
      initialState={queue ? null : {
        sorting: [
          {
            id: 'rank',
            desc: false,
          },
        ],
        
      }}
      
      //clicking anywhere on the row will select it
      muiTableBodyRowProps={({ row }) => ({
        onClick: row.getToggleSelectedHandler(),
        sx: getColorByPosition(row.getValue('position'))
      })}

      muiTableBodyCellProps={{
          //simple styling with the `sx` prop, works just like a style prop in this example
          sx: {
            color: 'black'
          },
      }}
      muiTableHeadCellProps={{
        sx: {
          "& .Mui-TableHeadCell-Content-Labels": {
            padding: "0px",
          },
          "& .MuiBox-root": {
            padding: "0px",
          },
        },
      }}
      muiTableBodyRowDragHandleProps={({ table }) => ({
        onDragEnd: () => {
          const { draggingRow, hoveredRow } = table.getState();
          if (hoveredRow && draggingRow && draggingRow !== hoveredRow) {
            var newData = [...data];
            newData.splice(
              hoveredRow.index,
              0,
              newData.splice(draggingRow.index, 1)[0],
            );
            setQueue(newData.map(data => data.id));
          }
        },
      })}

      />;
    </Box>
};

export default SelectPlayer;



